import { h } from 'preact';

import './iframe.scss';
import { PLAYER_CONTROL_EVENT } from 'constants/events';
import { BaseAnnotation } from 'rendering/annotations/base_annotation';
import { sendToIframe } from 'utilities/communication';
import { EXTENSION_API } from 'constants/events';
import { focusable } from 'utilities/accessibility';
import { expandable } from 'rendering/behaviors/expandable';
import { COMPOSITION_TYPES, getCompositionInfo } from 'constants/annotations';
import { ControlBar } from 'rendering/components/adjacent_control_bar';


export class IframeAnnotation extends BaseAnnotation {
    constructor(...args) {
        super(...args);

        this.eventBus.on(EXTENSION_API.ADD_CLASSES, this.addClass.bind(this));
        this.eventBus.on(EXTENSION_API.REMOVE_CLASSES, this.removeClass.bind(this));
    }

    onLoad() {
        sendToIframe(this.iframeEl.contentWindow, { event: 'annotationload', data: { ...this.legacyContext, customConfig: this.props.customConfig } });
        sendToIframe(this.iframeEl.contentWindow, { event: 'iframeshow', editMode: false });
    }

    addClass({classes:name}, sender) {
        if (!this.state.extraClasses.includes(name) && sender === this.iframeEl.contentWindow) {
            this.setState({
                extraClasses: this.state.extraClasses.concat(name)
            })
        }
    }

    removeClass({classes:name}, sender) {
        if (this.state.extraClasses.includes(name) && sender === this.iframeEl.contentWindow) {
            this.setState({
                extraClasses: this.state.extraClasses.filter(c => c !== name)
            })
        }
    }

    render() {
        const { showExpanded = false } = this.options;

        return (
            <div className={ this.classes } style={ this.getElementStyles() } { ...this.dataAttrs } { ...this.applyActions(this.actions) }>
                { showExpanded && (<ControlBar onExpand={ this.onExpandPlayerAnnotation } onCollapse={ this.onCollapsePlayerAnnotation } styles={ this.controlBarStyles }/>)}
                <iframe { ...this.iframeAttrs }/>
            </div>
        );
    }

    get iframeAttrs() {
        return {
            ref: el => this.iframeEl = el,
            title: this.options.altText,
            src: this.props.content,
            style: {
                width: '100%',
                height: '100%'
            },
            onLoad: this.onLoad.bind(this),
            frameborder: "0",
            scrolling: "auto",
            ...focusable
        }
    }

    get legacyClasses() {
        const base = [
            'popcorn-iframe',
            'active',
            (this.props.transitionClass || ''),
            ...this.state.extraClasses
        ];

        return base.join(' ');
    }

    get legacyContext() {
        if (this.props.data && this.props.data.legacyConfig) {
            const c = this.props.data.legacyConfig

            return {
                projectTrackId: c.track.id,
                annotationTrackId: this.props.id,
                projectConfig: c.project,
                groupConfig: c.configuration.player,
                configAPI: c.configuration,
                projectId: c.project.id
            }
        } else {
            console.warn('missing legacy config, iframe may not work as expected');
        }

        return {};
    }

    get defaultState() {
        const src = (this.props.content || '').replace(/^(\/\/)/, 'https://');

        return {
            src,
            extraClasses: []
        }
    }

    get classes() {
        return [
            ...super.classes,
            'iframe-annotation'
        ]
    }

    static get composition() {
        return getCompositionInfo('IFRAME');
    }

    static get schemaType() {
        return 'iframe';
    }
}